const navbarRoutes = ['/quote', '/account']; // Add your desired routes here

export default navbarRoutes;